import { Const } from '~/constants/Const.constant';
import {
    battery, lastActivity, lastSeen,
    notifyRule, recordRule, rfRating,
    sirenEntryDelay,
    sirenSoundRule
} from '~/helpers/fields-description';
import { rfStatus } from '~/helpers/network-fields-description';
import { NAModule } from '../NAModule.model';
export class NACamDoorTag extends NAModule {
    hasOperationImportData = false;
    hasOperationReset = false;

    battery?: number;
    rf?: number;
    rf_rating?: number; // percent compute if the tag has not event but tag move
    monitoring?: string;
    last_activity?: number;

    // Alert & Record on tags
    notify_rule?: string;
    record_rule?: string;
    siren_sound_rule?: string;
    siren_entry_delay_rule?: string;

    battery_levels = {
        full: Const.NABatteryLevelTag.TAG_BATTERY_LEVEL_0,
        high: Const.NABatteryLevelTag.TAG_BATTERY_LEVEL_1,
        medium: Const.NABatteryLevelTag.TAG_BATTERY_LEVEL_2,
        low: Const.NABatteryLevelTag.TAG_BATTERY_LEVEL_3,
    };

    isWired = false;

    get fieldBattery() {
        return battery(this.getBatteryIcon(this.battery), this.battery);
    }
    get fieldRfStatus() {
        return rfStatus(this.getRfIcon(this.rf), this.rf);
    }
    get fieldLastActivity() {
        return lastActivity(this.last_activity);
    }
    get fieldLastSeen() {
        return lastSeen(this.last_seen, this.outdatedLastSeen ? 'error--text' : '');
    }
    get fieldNotifyRule() {
        return notifyRule(this.notify_rule || Const.NACameraTagNotifyRule.CTNR_ALWAYS);
    }
    get fieldRecordRule() {
        return recordRule(this.record_rule || Const.NACameraTagRecordRule.CTRR_EMPTY);
    }
    get fieldRfRating() {
        if (this.rf_rating) {
            return rfRating(this.rf_rating);
        }
    }
    get fieldSirenSoundRule() {
        if (this.siren_sound_rule) {
            return sirenSoundRule(this.siren_sound_rule);
        }
    }
    get fieldSirenEntryDelay() {
        if (this.siren_sound_rule) {
            let sirenEntryDelayRule;
            if (this.siren_entry_delay_rule) {
                sirenEntryDelayRule = (this.siren_sound_rule === Const.NACameraSireneSoundRule.CSSR_NEVER) ?
                    Const.NACameraSireneSoundRule.CSSR_NEVER : Const.NACameraSireneSoundRule.CSSR_EMPTY;
            }
            return sirenEntryDelay(sirenEntryDelayRule);
        }
    }
}
